import { SimpleGrid } from "@mantine/core";
import { IconClockHour4 } from "@tabler/icons-react";
import { StatCard } from "../StatCard";

interface Fact {
  label: string;
  value: string;
}

export function ProfileKeyFacts({ facts }: { facts: Fact[] }) {
  return (
    <SimpleGrid cols={{ base: 1, md: 2, lg: 4 }} spacing="md">
      {facts.map((fact) => (
        <StatCard key={fact.label} label={fact.label} value={fact.value} icon={IconClockHour4} />
      ))}
    </SimpleGrid>
  );
}
